interface LiveDotProps {
  active?: boolean;
}

export function LiveDot({ active = false }: LiveDotProps) {
  return (
    <div className="relative flex items-center justify-center w-2.5 h-2.5">
      {active ? (
        <>
          <div className="h-2.5 w-2.5 rounded-full bg-red-500 animate-pulse" />
          <div className="absolute h-2.5 w-2.5 rounded-full bg-red-500 opacity-50 animate-ping" />
        </>
      ) : (
        <div className="h-1.5 w-1.5 rounded-full bg-muted-foreground/50" />
      )}
    </div>
  );
}
